<script>
export default {
    name: 'UiButton',
    props: {
        type: {
            type: String,
            validator: function(value) {
                return ['filled', 'outline', 'text', 'icon'].includes(value)
            },
            default: 'filled'
        },
        noAnimation: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            validator: function(value) {
                return ['ghost', 'light', 'gray', 'dark', 'primary'].includes(value)
            },
            default: 'light'
        },
        size: {
            type: String,
            validator: function(value) {
                return ['extra-small', 'small', 'normal', 'medium', 'large'].includes(value)
            },
            default: 'small'
        },
        to: {
            type: [ Object, null ],
            default: () => null
        },
        href: {
            type: String,
            default: undefined,
        },
        clickCallback: {
            type: Function,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        clickEvent() {
            if (this.to) {
                this.$router.push(this.to)
            }
            if(this.clickCallback) {
                this.clickCallback()
            }
        }
    }
}
</script>

<template>
    <component
        :is="href ? 'a' : 'button'"
        class="ui-button granat"
        :disabled="disabled"
        :class="[
            type,
            color,
            size,
            {
                'no-animation': noAnimation,
                'full-width': fullWidth,
            },
        ]"
        :href="href"
        v-bind="$attrs"
        v-on="$listeners"
        @click="clickEvent"
    >
        <slot name="prefix" />
        <p v-if="$slots.default && !isLoading">
            <slot />
        </p>
        <div
            v-else-if="isLoading"
            class="loading-spinner"
        />
        <slot name="suffix" />
    </component>
</template>

<style lang="scss" scoped>
    @import "design/style";
</style>